import { getOperatorId } from '@/helpers/jwt';
import { Stack } from '@mui/material';
import MachineCoinsSettings from './MachineCoinsSettings';
import MachineProductsSettings from './MachineProductsSettings';

const MachineProducts = () => {
  const operatorId = getOperatorId();

  return (
    <Stack pt={2} gap={2}>
      <MachineCoinsSettings />
      {(operatorId === 49 || operatorId === 2) && <MachineProductsSettings />}
    </Stack>
  );
};

export default MachineProducts;
